'use client'
import styled from 'styled-components'
import colors from "common/theme/saasModern/colors"

export const Section = styled.div`
  display: flex;
  align-items: center;
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  margin: 0 auto;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 1rem;
    text-align: center;
  }
`

export const AccordionSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

export const AccordionItem = styled.div`
  background: #F9FAFB;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
`

export const AccordionHeader = styled.button`
  width: 100%;
  padding: 1rem 1.5rem;
  font-weight: 900;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: none;
  border: none;
  color: black;
  font-size: 1.1rem;
  text-align: left;
  cursor: pointer;
  background-color: ${props => props.isOpen ? 'rgba(255, 255, 255, 0.05)' : ''};
  @media (max-width: 950px) {
    font-size: 0.75rem;
    padding: 1rem 1rem;
  }
  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`

export const AccordionContent = styled.div`
  max-height: ${props => props.isOpen ? '500px' : '0'};
  overflow: hidden;
  transition: 0.3s ease-in-out;
  font-weight: 500;
  padding: ${props => props.isOpen ? '1rem 1.5rem' : '0 1.5rem'};
  color: black;
  font-size: 1rem;
  @media (max-width: 950px) {
    font-size: 0.75rem;
  }
`

export const ContentSection = styled.div`
  flex: 1;
  text-align: center;
`

export const Subtitle = styled.div`
  color: ${colors.black};
  font-size: 1.5rem;
  transition: 500ms;
  font-weight: 500;
  @media (max-width: 1440px) {
    font-size: 1.25rem;
  }
  @media (max-width: 950px) {
    font-size: 1rem;
  }
`

export const PlusIcon = styled.span`
  color: black;
  font-size: 1.5rem;
`

export const Heading = styled.h2`
  font-size: 3rem;
  font-weight: 900;
  margin: 0;
  transition: 500ms;
  @media (max-width: 1440px) {
    font-size: 3rem;
  }
  @media (max-width: 950px) {
    font-size: 1.75rem;
  }
`

export const GradientText = styled.span`
  background: linear-gradient(to right, #3b82f6, #ec4899, #f97316);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`
 
 